// extracted by mini-css-extract-plugin
export var projects = "Carousel-module--projects--3AMOu";
export var news = "Carousel-module--news--G1X6L";
export var section = "Carousel-module--section--31aI5";
export var head = "Carousel-module--head--1W_90";
export var heading = "Carousel-module--heading--VlJ6H";
export var marker = "Carousel-module--marker--3Hvl3";
export var markerLight = "Carousel-module--markerLight--2O0C_";
export var markerDark = "Carousel-module--markerDark--2TaqR";
export var controls = "Carousel-module--controls--ODKCL";
export var control = "Carousel-module--control--3cMUL";
export var toggle = "Carousel-module--toggle--RF_z7";
export var counter = "Carousel-module--counter--2QUfZ";
export var viewport = "Carousel-module--viewport--2TvVY";
export var track = "Carousel-module--track--3Txyg";
export var slide = "Carousel-module--slide--21o01";
export var card = "Carousel-module--card--3JRSB";
export var cardHead = "Carousel-module--cardHead--2mfJH";
export var cardTitle = "Carousel-module--cardTitle--1yzWY";
export var date = "Carousel-module--date--b9BG5";
export var media = "Carousel-module--media--2U2_Z";
export var excerpt = "Carousel-module--excerpt--2Zt6_";